import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class TileVersionService {
  private versionToken = '1';

  getVersionToken(): string {
    return this.versionToken;
  }

  incrementVersionToken(): void {
    // Update the version token to a new value, e.g., a timestamp or a random number
    this.versionToken = new Date().getTime().toString();
  }
} 	